var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"color":"error","disabled":_vm.loading,"loading":_vm.loading,"depressed":"","x-small":""},on:{"click":_vm.createJob}},'v-btn',_vm.$props,false),[_vm._v(" "+_vm._s(_vm.jobDefinition.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }